import { useTranslation } from 'gatsby-plugin-react-i18next'
import React from 'react'

import CloseArrow from '../../../images/close.svg'
import Form from '../../form/Form'
import ModalSocial from './ModalSocial'

type Props = {
  onClose: () => void
}

const GetAccessForm: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation()

  return (
    <>
      <button className="modal__close" onClick={onClose}>
        <img src={CloseArrow} />
      </button>
      <div className="modal__title">{t('Get exclusive access to MealPal')}</div>
      <div className="modal__content">
        <Form customClass="form--hero form--modal" position="dinner-hero" cities={[]} />
      </div>
      <ModalSocial />
    </>
  )
}

export default GetAccessForm
